import PropTypes from 'prop-types';
import React from 'react';

import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading, SubHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { withScrollTop } from '../../containers/withScrollTop';
import { ContentProps } from '../state/propTypes';

import { WarningDescription } from './WarningDescription';

const Acknowledgement = (props) => {
	const {
		outcome: { fraud_description: fraudDescription, scamIndicators = [] },
		content: { pageHeading, pageSubHeading, bulletPointsHeader, importantWarningDescription },
	} = props;

	const itemList = scamIndicators.map(({ para }) => <WarningDescription data={para} />);

	return (
		<div>
			<PageHeading data-test-id="acknowledgement">{pageHeading}</PageHeading>
			<p>{pageSubHeading}</p>
			<StandardBody>
				<p>{fraudDescription}</p>
			</StandardBody>
			<SubHeading>{bulletPointsHeader}</SubHeading>
			<BulletList items={itemList} />
			<StandoutTile.Important>
				<StandardBody>
					<p>{importantWarningDescription}</p>
				</StandardBody>
			</StandoutTile.Important>
		</div>
	);
};

Acknowledgement.propTypes = {
	outcome: PropTypes.shape({
		fraud_description: PropTypes.string,
		scamIndicators: PropTypes.arrayOf(PropTypes.shape({})),
	}),
	content: PropTypes.shape(ContentProps),
};

export default withScrollTop(Acknowledgement);
